export default __webpack_public_path__ + "static/media/learning_5.4d269b8c.svg";